module.exports = __webpack_public_path__ + "img/logo_afs.2e532bb7.png";